import React, { useState, useCallback, useEffect } from "react";
//#region redux
import { useDispatch } from "react-redux";
import { displayErrorMessage } from "store/actions/utilActions";
//#endregion
//#region types
import { ReApproveContextState, ReApproveProviderProps } from "models/propTypes/wintSalaryPropTypes";
import { WintSuperkollAPIModelWintSalaryReport } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ReApproveContext } from "./index";
import { useWintSalaryService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

export const ReApproveProvider: React.FC<ReApproveProviderProps> = ({ personId, yearMonth, children }) => {
  const [personData, setPersonData] = useState<WintSuperkollAPIModelWintSalaryReport.WintSalaryReportRow | undefined>(
    undefined
  );
  const [loading, setLoading] = useState(false);
  const [monthlySalary, setMonthlySalary] = useState<number | undefined>(undefined);
  const [socialFees, setSocialFees] = useState<number | undefined>(undefined);
  const [privateTax, setPrivateTax] = useState<number | undefined>(undefined);
  const [netSalary, setNetSalary] = useState<number | undefined>(undefined);

  const { getPersonSalaryReport } = useWintSalaryService();

  const dispatch = useDispatch();

  const onError = (error: any) => {
    error &&
      dispatch(
        displayErrorMessage(
          LocalizationHelperInstance.getFormattedMessage(error?.message ?? TranslationKeys.Errors.SomethingWentWrong),
          {
            isGlobal: true,
          }
        )
      );
  };

  const fetchPersonReportData = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getPersonSalaryReport(personId, yearMonth);
      setPersonData(result);
      setMonthlySalary(result.columns?.[0]?.amount);
      setSocialFees(0);
      setPrivateTax(result.payoutDetails?.taxAmount);
      setNetSalary(result.payoutDetails?.netPayment);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  }, [personId, yearMonth]);

  useEffect(() => {
    fetchPersonReportData();
  }, [fetchPersonReportData]);

  const value: ReApproveContextState = {
    personData,
    loading,
    fetchPersonReportData,
    monthlySalary,
    socialFees,
    privateTax,
    netSalary,
  };

  return <ReApproveContext.Provider value={value}>{children}</ReApproveContext.Provider>;
};
